export const workflow = {
  errors: {
    noStep: 'No current step in response',
    failedToExecute: 'Failed to execute workflow',
    failedToGoBack: 'Failed to go back',
  },
};
